import React, { useState, useRef, useEffect } from "react";
import { Button, Table, Modal, Form, Input, Select, message, Row, Col, Checkbox, Popconfirm, List, Card } from 'antd';
import * as XLSX from 'xlsx';
import { isValid, isValidArray, isValidArrayWithValues, isValidString } from "../../../utils/utilities";
import { createAddressLocation } from "../../../actions/address.actions";
import { getAddressLocations } from "../../../actions/trip-create.actions";
import { loadingAction } from "../../../actions/loading-actions";
import { useDispatch, useSelector } from "react-redux";
import { loadingReducerSelector } from "../../../selector/loading-selectors";

const { Option } = Select;

export const RouteExcelComponent = (props) => {
    const {
        masterCities,
        updateSelectedCity,
        onRouteCreated
    } = props;
    const [routeData, setRouteData] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingKey, setEditingKey] = useState('');
    const fileInputRef = useRef(null);
    const qwikbusFileInputRef = useRef(null);
    const [form] = Form.useForm();

    const dispatch = useDispatch();
    
    // Get global loading state from Redux
    const { loadingActionRunning } = useSelector(loadingReducerSelector);
    
    // New state for city confirmation
    const [isCityConfirmationVisible, setIsCityConfirmationVisible] = useState(false);
    const [cityMatches, setCityMatches] = useState([]);
    const [pendingRouteData, setPendingRouteData] = useState([]);
    const [selectedCityMappings, setSelectedCityMappings] = useState({});
    const [isCreatingRoute, setIsCreatingRoute] = useState(false);
    
    // State for existing addresses
    const [existingAddresses, setExistingAddresses] = useState([]);
    const [addressesLoaded, setAddressesLoaded] = useState(false);

    const setLoading = (bool) => {
        dispatch(loadingAction(bool));
    };

    // Function to validate pin code
    const isValidPinCode = (pinCode) => {
        if (!pinCode || typeof pinCode !== 'string') {
            return false;
        }
        
        // Remove any non-digit characters
        const cleanPin = pinCode.replace(/\D/g, '');
        
        // Check if it's exactly 6 digits
        if (cleanPin.length !== 6) {
            return false;
        }
        
        // Check if it's all zeros
        if (cleanPin === '000000') {
            return false;
        }
        
        // Check if it's a valid Indian PIN code format
        // Indian PIN codes should not start with 0 and should be between 100000 and 999999
        const pinNumber = parseInt(cleanPin, 10);
        if (pinNumber < 100000 || pinNumber > 999999) {
            return false;
        }
        
        return true;
    };

    // Sample data for testing
    let sampleData = [["Bhaiya Travels Ashok Udyan Pal Road","Bhaiya Travels","Jodhpur","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near Bhaiya Travels Ashok Udyan Pal Road",8690788841,null,null,0.6041666666666666,"Bhaiya travels ashok udyan pal road,"],[null,null,null,null,null,"Jodhpur, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bhaiya Travels Kaazri Road","Bhaiya Travels","Jodhpur","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near Bhaiya Travels Kaazri Road",8690788841,null,null,0.611111111111111,"Bhaiya travels kaazri road,"],[null,null,null,null,null,"Jodhpur, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Mandi Mod","Bhaiya Travels","Jodhpur","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near Mandi Mod",8690788841,null,null,0.625,"Mandi mod,"],[null,null,null,null,null,"Jodhpur, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["BY PASS","Bhaiya Travels","Rohat","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near By Pass",8690788841,null,null,0.6527777777777778,"By pass,"],[null,null,null,null,null,"Rohat, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","DRIVER","Pali","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.6805555555555555,"Bypass,"],[null,null,null,null,null,"Pali, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["sojat bus stand","DRIVER","Sojat","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near Sojat Bus Stand",8690788841,null,null,0.6979166666666666,"Sojat bus stand ,"],[null,null,null,null,null,"Sojat, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["BUS STAND","Bhaiya Travels","Bar","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near Bus Stand",8690788841,null,null,0.7291666666666666,"Bus stand,"],[null,null,null,null,null,"Bar, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bus Stand Beawar","Bhaiya Travels","Beawar","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near Bus Stand Beawar",8690788841,null,null,0.7708333333333334,"Bus stand beawar,"],[null,null,null,null,null,"Beawar, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Kishangarh","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.8611111111111112,"Bypass,"],[null,null,null,null,null,"Kishangarh, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["200 ft pass","Bhaiya Travels","Jaipur","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near 200 Ft Pass",8690788841,null,null,0.9166666666666666,"200 ft pass,"],[null,null,null,null,null,"Jaipur, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["MOTILAL ATAL ROAD POLO VICTORY ","JAKHAR TRAVELS SHREE KRISHNA TRAVELS","Jaipur","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near TOWER SHOP NO 13 NEAR NATRAJ HOTEL MOTILAL ATAL ROAD POLO VICTORY ","9413799996 9783058888",null,null,0.9375,"Tower shop no 13 near natraj hotel motilal atal road polo victory ,"],[null,null,null,null,null,"Jaipur, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Dausa","Boarding at","1st Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.9583333333333334,"Bypass,"],[null,null,null,null,null,"Dausa, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Bharatpur","Boarding at","2nd Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0,"Bypass,"],[null,null,null,null,null,"Bharatpur, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Agra","Boarding at","2nd Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.0625,"Bypass,"],[null,null,null,null,null,"Agra, "],[null,null,null,null,null,"Uttar pradesh, "],[null,null,null,null,null,"Pin: 000000"],["BYPASS","Bhaiya Travels","Kanpur","Boarding at","2nd Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.25,"Bypass,"],[null,null,null,null,null,"Kanpur, "],[null,null,null,null,null,"Uttar pradesh, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Fatehpur","Boarding at","2nd Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.3611111111111111,"Bypass,"],[null,null,null,null,null,"Fatehpur, "],[null,null,null,null,null,"Uttar pradesh, "],[null,null,null,null,null,"Pin: 000000"],["sojat bus stand","DRIVER","Sojat","Drop Off","1st Day",",",null,"Edit","Delete","Show"],["Near Sojat Bus Stand",8690788841,null,null,0.6979166666666666,"Sojat bus stand ,"],[null,null,null,null,null,"Sojat, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["BUS STAND","Bhaiya Travels","Bar","Drop Off","1st Day",",",null,"Edit","Delete","Show"],["Near Bus Stand",8690788841,null,null,0.7291666666666666,"Bus stand,"],[null,null,null,null,null,"Bar, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bus Stand Beawar","Bhaiya Travels","Beawar","Drop Off","1st Day",",",null,"Edit","Delete","Show"],["Near Bus Stand Beawar",8690788841,null,null,0.7708333333333334,"Bus stand beawar,"],[null,null,null,null,null,"Beawar, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["KALPANA TRAVELS BYPASS AJMER","Bhaiya Travels","Ajmer","Drop Off","1st Day",","],["Near Kalpana Travels Bypass Ajmer",8690788841,null,null,0.8333333333333334,"Kalpana travels bypass ajmer,"],[null,null,null,null,null,"Ajmer, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Kishangarh","Drop Off","1st Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.8611111111111112,"Bypass,"],[null,null,null,null,null,"Kishangarh, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["200 ft pass","Bhaiya Travels","Jaipur","Drop Off","1st Day",",",null,"Edit","Delete","Show"],["Near 200 Ft Pass",8690788841,null,null,0.9166666666666666,"200 ft pass,"],[null,null,null,null,null,"Jaipur, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["MOTILAL ATAL ROAD POLO VICTORY ","JAKHAR TRAVELS SHREE KRISHNA TRAVELS","Jaipur","Drop Off","1st Day",",",null,"Edit","Delete","Show"],["Near TOWER SHOP NO 13 NEAR NATRAJ HOTEL MOTILAL ATAL ROAD POLO VICTORY ","9413799996 9783058888",null,null,0.9375,"Tower shop no 13 near natraj hotel motilal atal road polo victory ,"],[null,null,null,null,null,"Jaipur, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Dausa","Drop Off","1st Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.9583333333333334,"Bypass,"],[null,null,null,null,null,"Dausa, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Bharatpur","Drop Off","2nd Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0,"Bypass,"],[null,null,null,null,null,"Bharatpur, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Agra","Drop Off","2nd Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.0625,"Bypass,"],[null,null,null,null,null,"Agra, "],[null,null,null,null,null,"Uttar pradesh, "],[null,null,null,null,null,"Pin: 000000"],["BYPASS","Bhaiya Travels","Kanpur","Drop Off","2nd Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.25,"Bypass,"],[null,null,null,null,null,"Kanpur, "],[null,null,null,null,null,"Uttar pradesh, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Fatehpur","Drop Off","2nd Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.3611111111111111,"Bypass,"],[null,null,null,null,null,"Fatehpur, "],[null,null,null,null,null,"Uttar pradesh, "],[null,null,null,null,null,"Pin: 000000"],["Bypass","Bhaiya Travels","Khaga","Drop Off","2nd Day",",",null,"Edit","Delete","Show"],["Near Bypass",8690788841,null,null,0.3958333333333333,"Bypass,"],[null,null,null,null,null,"Khaga, "],[null,null,null,null,null,"Uttar pradesh, "],[null,null,null,null,null,"Pin: 000000"],["Leprosy circle Indian oil pump Rewa road","Bhaiya Travels","Prayagraj","Drop Off","2nd Day",","],["Near Leprosy Circle Indian Oil Pump Rewa Road",9335137837,null,null,0.4375,"Leprosy circle indian oil pump rewa road,"],[null,null,null,null,null,"Prayagraj, "],[null,null,null,null,null,"Uttar pradesh, "],[null,null,null,null,null,"Pin: 000000"],["Bhaiya Travels Rohniya near BJP office DIRECT BUS ","Bhaiya Travels","Varanasi","Drop Off","2nd Day",",",null,"Edit","Delete","Show"],["Near Rohniya near BJP office","8690788842 8690788841",null,null,0.4583333333333333,"Rohniya near bjp office,"],[null,null,null,null,null,"Varanasi, "],[null,null,null,null,null,"Uttar pradesh, "],[null,null,null,null,null,"Pin: 000000"],["KALPANA TRAVELS BYPASS AJMER","Bhaiya Travels","Ajmer","Boarding at","1st Day",","],["Near Kalpana Travels Bypass Ajmer",8690788841,null,null,0.8333333333333334,"Kalpana travels bypass ajmer,"],[null,null,null,null,null,"Ajmer, "],[null,null,null,null,null,"Rajasthan, "],[null,null,null,null,null,"Pin: 000000"]];

    // Fetch existing addresses when component mounts
    useEffect(() => {
        if (!isValidArrayWithValues(existingAddresses)) {
            dispatch(getAddressLocations(null, false, 
                (data) => {
                    setExistingAddresses(data.addressLocations || []);
                    setAddressesLoaded(true);
                },
                (errorMsg) => {
                    setAddressesLoaded(true); // Mark as loaded even if failed
                }
            ));
        }
    }, [existingAddresses]);

    // Function to find matching cities in masterCities with enhanced matching logic
    const findCityMatches = (cityName, stateName = null) => {
        if (!cityName || !masterCities || !Array.isArray(masterCities)) {
            return [];
        }
        
        const normalizedCityName = cityName.toLowerCase().trim();
        const normalizedStateName = stateName ? stateName.toLowerCase().trim() : null;
        const matches = [];
        
        masterCities.forEach(city => {
            let matchType = null;
            let score = 0;
            
            // Check exact match with city_name (highest priority)
            if (city.city_name && city.city_name.toLowerCase().trim() === normalizedCityName) {
                matchType = 'exact';
                score = 100;
            }
            // Check exact match with alias_city_name
            else if (city.alias_city_name && city.alias_city_name.toLowerCase().trim() === normalizedCityName) {
                matchType = 'alias_exact';
                score = 90;
            }
            // Check if city_name contains the search term (partial match)
            else if (city.city_name && city.city_name.toLowerCase().includes(normalizedCityName)) {
                matchType = 'partial';
                score = 50;
            }
            // Check if alias_city_name contains the search term
            else if (city.alias_city_name && city.alias_city_name.toLowerCase().includes(normalizedCityName)) {
                matchType = 'partial_alias';
                score = 40;
            }
            
            // If we found a match, add state matching bonus
            if (matchType && normalizedStateName && city.state_name) {
                const cityStateName = city.state_name.toLowerCase().trim();
                if (cityStateName === normalizedStateName) {
                    score += 20; // State match bonus
                    matchType = matchType + '_state_match';
                } else if (cityStateName.includes(normalizedStateName) || normalizedStateName.includes(cityStateName)) {
                    score += 10; // Partial state match bonus
                    matchType = matchType + '_state_partial';
                }
            }
            
            if (matchType) {
                matches.push({ 
                    ...city, 
                    matchType, 
                    score,
                    autoSelect: score >= 110 // Auto-select if exact match + state match
                });
            }
        });
        
        // Sort by score (highest first) and then by city name
        matches.sort((a, b) => {
            if (b.score !== a.score) {
                return b.score - a.score;
            }
            return a.city_name.localeCompare(b.city_name);
        });
        
        return matches;
    };

    // Function to check for city matches in extracted data
    const checkCityMatches = (extractedData) => {
        const matches = [];
        const uniqueCities = [...new Set(extractedData.map(record => record.city))];
        
        uniqueCities.forEach(cityName => {
            // Find all records with this city to get state information
            const recordsWithCity = extractedData.filter(record => record.city === cityName);
            const stateName = recordsWithCity.find(record => record.state)?.state || null;
            
            const cityMatches = findCityMatches(cityName, stateName);
            
            if (cityMatches.length > 1) {
                // Check if we have an auto-select candidate
                const autoSelectCandidate = cityMatches.find(match => match.autoSelect);
                
                if (autoSelectCandidate) {
                    // Auto-select the best match but still show confirmation
                    matches.push({
                        excelCity: cityName,
                        matches: cityMatches,
                        type: 'auto_select',
                        autoSelectedCity: autoSelectCandidate
                    });
                } else {
                    matches.push({
                        excelCity: cityName,
                        matches: cityMatches,
                        type: 'multiple'
                    });
                }
            } else if (cityMatches.length === 1) {
                // Single match found - auto-select it but still show confirmation
                matches.push({
                    excelCity: cityName,
                    matches: cityMatches,
                    type: 'auto_select',
                    autoSelectedCity: cityMatches[0]
                });
            } else if (cityMatches.length === 0) {
                // No matches found - use all master cities like city-select.js
                matches.push({
                    excelCity: cityName,
                    matches: masterCities || [],
                    type: 'no_match'
                });
            }
        });
        
        return matches;
    };

    const extractRecords = (data) => {
        try {
            const result = [];
            let i = 0;

            while (i < data.length) {
                const row = data[i];
                
                // Check if this is a valid entry row (has location name, updatedBy, city, and boarding/drop info)
                if (row.length >= 4 && row[0] && row[1] && row[2] && row[3] && 
                    (row[3].includes('Boarding at') || row[3].includes('Drop Off'))) {
                    
                    // Extract basic data from columns
                    const locationName = row[0] || '';
                    const updatedBy = row[1] || '';
                    const city = row[2] || '';
                    const boardingDrop = row[3] || '';
                    const dayText = row[4] || '';
                    
                    // Determine boarding and drop flags
                    let boarding = false;
                    let drop = false;
                    if (boardingDrop.includes('Boarding at')) {
                        boarding = true;
                    } else if (boardingDrop.includes('Drop Off')) {
                        drop = true;
                    }
                    
                    // Convert day text to number
                    let day = 0;
                    if (dayText.includes('1st')) day = 1;
                    else if (dayText.includes('2nd')) day = 2;
                    else if (dayText.includes('3rd')) day = 3;
                    else if (dayText.includes('4th')) day = 4;
                    
                    // Get contact numbers and landmark from next row (column B and A)
                    let contacts = [];
                    let landmark = '';
                    if (i + 1 < data.length) {
                        const nextRow = data[i + 1];
                        
                        // Extract landmark from column A (index 0)
                        if (nextRow[0] !== null && nextRow[0] !== undefined && nextRow[0] !== '') {
                            landmark = nextRow[0].toString().trim();
                        }
                        
                        // Extract contact numbers from column B (index 1)
                        if (nextRow[1] !== null && nextRow[1] !== undefined && nextRow[1] !== '') {
                            // Handle both string and numeric contact numbers
                            let contactValue = nextRow[1].toString();
                            
                            // Split by spaces and process each part
                            contacts = contactValue
                                .split(/\s+/)
                                .map(num => num.trim().replace(/\D/g, ''))
                                .filter(num => num.length === 10 || num.length === 11)
                                .map(num => num.length === 11 ? num.slice(1) : num);
                        }
                    }
                    
                    // Build complete address from current and following rows (column F)
                    let addressParts = [];
                    let j = 0;
                    
                    // Start with the current row's address part (column F)
                    if (row[5] && row[5].trim() !== '') {
                        addressParts.push(row[5].trim());
                    }
                    
                    // Continue with subsequent rows until we hit a new entry
                    while (i + j + 1 < data.length) {
                        const nextRow = data[i + j + 1];
                        
                        // Stop if we hit a new entry
                        if (nextRow.length >= 4 && nextRow[0] && nextRow[1] && nextRow[2] && nextRow[3] && 
                            (nextRow[3].includes('Boarding at') || nextRow[3].includes('Drop Off'))) {
                            break;
                        }
                        
                        // Add address part from column F
                        if (nextRow[5] && nextRow[5].trim() !== '') {
                            addressParts.push(nextRow[5].trim());
                        }
                        j++;
                    }
                    
                    // Extract pin code if available
                    let pinCode = '';
                    const pinMatch = addressParts.find(part => part.includes('Pin:'));
                    if (pinMatch) {
                        pinCode = pinMatch.replace('Pin:', '').trim();
                        // Remove the pin code part from address parts
                        addressParts = addressParts.filter(part => !part.includes('Pin:'));
                    }
                    
                    // Clean and join address parts, then merge with pin code
                    let address = addressParts
                        .filter(part => part !== '' && part.trim() !== '')
                        .join(', ')
                        .replace(/,\s*,/g, ',')  // Remove duplicate commas
                        .replace(/\s+/g, ' ')   // Remove extra spaces
                        .replace(/^[,\s]+|[,\s]+$/g, '')  // Remove leading/trailing commas and spaces
                        .trim();
                    
                    // Add pin code to address only if it's valid (not all zeros and proper format)
                    if (pinCode && isValidPinCode(pinCode)) {
                        address = address ? `${address}, Pin: ${pinCode}` : `Pin: ${pinCode}`;
                    }
                    
                    // Extract time from the next row (column E, index 4) - this is where the time value is stored
                    let time = '';
                    if (i + 1 < data.length) {
                        const nextRow = data[i + 1];
                        if (nextRow[4] !== null && nextRow[4] !== undefined && nextRow[4] !== '') {
                            // Convert Excel time format to HH:MM:SS
                            if (typeof nextRow[4] === 'number') {
                                // Excel stores time as fraction of day
                                const totalSeconds = Math.round(nextRow[4] * 24 * 60 * 60);
                                const hours = Math.floor(totalSeconds / 3600);
                                const minutes = Math.floor((totalSeconds % 3600) / 60);
                                const seconds = totalSeconds % 60;
                                time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                            } else {
                                time = nextRow[4].toString().trim();
                            }
                        }
                    }
                    
                    // Extract state from address parts
                    let state = '';
                    const stateMatch = addressParts.find(part => 
                        part.toLowerCase().includes('rajasthan') || 
                        part.toLowerCase().includes('uttar pradesh') ||
                        part.toLowerCase().includes('maharashtra') ||
                        part.toLowerCase().includes('gujarat') ||
                        part.toLowerCase().includes('madhya pradesh') ||
                        part.toLowerCase().includes('bihar') ||
                        part.toLowerCase().includes('west bengal') ||
                        part.toLowerCase().includes('odisha') ||
                        part.toLowerCase().includes('jharkhand') ||
                        part.toLowerCase().includes('chhattisgarh') ||
                        part.toLowerCase().includes('andhra pradesh') ||
                        part.toLowerCase().includes('telangana') ||
                        part.toLowerCase().includes('karnataka') ||
                        part.toLowerCase().includes('tamil nadu') ||
                        part.toLowerCase().includes('kerala') ||
                        part.toLowerCase().includes('goa') ||
                        part.toLowerCase().includes('punjab') ||
                        part.toLowerCase().includes('haryana') ||
                        part.toLowerCase().includes('himachal pradesh') ||
                        part.toLowerCase().includes('uttarakhand') ||
                        part.toLowerCase().includes('jammu') ||
                        part.toLowerCase().includes('assam') ||
                        part.toLowerCase().includes('arunachal pradesh') ||
                        part.toLowerCase().includes('manipur') ||
                        part.toLowerCase().includes('meghalaya') ||
                        part.toLowerCase().includes('mizoram') ||
                        part.toLowerCase().includes('nagaland') ||
                        part.toLowerCase().includes('tripura') ||
                        part.toLowerCase().includes('sikkim')
                    );
                    
                    if (stateMatch) {
                        state = stateMatch.trim();
                    }
                    
                    // Create the complete object
                    const entry = {
                        locationName: locationName.trim(),
                        landmark: landmark,
                        contact: contacts,
                        city: city.trim(),
                        state: state,
                        boarding: boarding,
                        drop: drop,
                        day: day,
                        time: time,
                        address: address
                    };
                    
                    result.push(entry);
                    
                    // Move to next potential entry
                    i += j + 1;
                } else {
                    // Not a valid entry row, move to next row
                    i++;
                }
            }
            
            // Combine duplicate entries with same location details but different boarding/drop flags
            const combinedResult = [];
            const seenEntries = new Map();
            
            result.forEach(entry => {
                // Create a key based on location details (excluding boarding/drop flags)
                const key = `${entry.locationName}|${entry.contact.join(',')}|${entry.city}|${entry.day}|${entry.time}|${entry.address}`;
                
                if (seenEntries.has(key)) {
                    // Found a duplicate, combine the boarding/drop flags
                    const existingEntry = seenEntries.get(key);
                    existingEntry.boarding = existingEntry.boarding || entry.boarding;
                    existingEntry.drop = existingEntry.drop || entry.drop;
                } else {
                    // New entry, add to map and result
                    seenEntries.set(key, { ...entry });
                    combinedResult.push(seenEntries.get(key));
                }
            });
            
            // Sort the results by day first, then by time
            combinedResult.sort((a, b) => {
                // First sort by day
                if (a.day !== b.day) {
                    return a.day - b.day;
                }
                
                // If days are equal, sort by time
                if (a.time && b.time) {
                    return a.time.localeCompare(b.time);
                }
                
                // If one has time and other doesn't, put the one with time first
                if (a.time && !b.time) return -1;
                if (!a.time && b.time) return 1;
                
                return 0;
            });
            
            message.success(`Successfully extracted ${combinedResult.length} route records!`);
            
            return combinedResult;
            
        } catch (error) {
            message.error('Failed to extract route data');
            return [];
        }
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        
        if (!file) {
            return;
        }

        // Check if file is Excel format
        const fileExtension = file.name.split('.').pop().toLowerCase();
        if (!['xlsx', 'xls'].includes(fileExtension)) {
            message.error('Please select a valid Excel file (.xlsx or .xls)');
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                
                // Get the first sheet
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                
                // Convert sheet to JSON
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                
                // Remove empty rows
                const filteredData = jsonData.filter(row => 
                    row && row.length > 0 && row.some(cell => cell !== null && cell !== '')
                );
                
                // Call extractRecords with the processed data
                const extractedData = extractRecords(filteredData);
                
                // Check for city matches
                const matches = checkCityMatches(extractedData);
                
                if (matches.length > 0) {
                    // Show city confirmation modal
                    setCityMatches(matches);
                    setPendingRouteData(extractedData);
                    setIsCityConfirmationVisible(true);
                } else {
                    // No matches found, proceed directly
                    setRouteData(extractedData);
                    setIsModalVisible(true);
                }
                
            } catch (error) {
                message.error('Failed to read Excel file');
            }
        };
        
        reader.readAsArrayBuffer(file);
        
        // Reset the file input
        event.target.value = '';
    };

    const handleImportClick = () => {
        fileInputRef.current.click();
    };

    // Extract records from QwikBus Schedule Export Excel
    const extractRecordsFromScheduleExport = (data) => {
        try {
            const result = [];
            
            // Skip header row
            let i = 1;
            let currentCity = ''; // Track the current city name
            
            while (i < data.length) {
                const row = data[i];
                
                // Skip empty rows
                if (!row || row.length === 0 || !row.some(cell => cell !== null && cell !== '')) {
                    i++;
                    continue;
                }
                
                const city = row[0]; // City column
                const stopName = row[1]; // Stop Name column
                const timing = row[2]; // Timing column
                const day = row[3]; // Day column
                const isBoarding = row[4]; // Is Boarding column
                const isDrop = row[5]; // Is Drop column
                const phoneNumber = isValidString(row[6])?row[6]:global.phoneNumber; // Phone Number column
                const landlineNumber = isValidString(row[7])?row[7]:global.landlineNumber; // Landline Number column
                
                console.log({phoneNumber},row[6],global.phoneNumber);
                console.log({landlineNumber},row[7],global.landlineNumber);
                
                // Check if this is a city header row (has city name but no stop name)
                if (city && city.trim() !== '' && (!stopName || stopName.trim() === '')) {
                    // This is a city header row, store the current city
                    currentCity = city.trim();
                    i++;
                    continue;
                }
                
                // Check if this is a stop row (has stop name)
                if (stopName && stopName.trim() !== '') {
                    // Extract contact numbers
                    let contacts = [];
                    if (phoneNumber && phoneNumber.toString().trim() !== '') {
                        const phoneStr = phoneNumber.toString().trim();
                        const phoneNums = phoneStr.split(/[,\s]+/)
                            .map(num => num.replace(/\D/g, ''))
                            .filter(num => num.length === 10 || num.length === 11)
                            .map(num => num.length === 11 ? num.slice(1) : num);
                        contacts.push(...phoneNums);
                    }
                    if (landlineNumber && landlineNumber.toString().trim() !== '') {
                        const landlineStr = landlineNumber.toString().trim();
                        const landlineNums = landlineStr.split(/[,\s]+/)
                            .map(num => num.replace(/\D/g, ''))
                            .filter(num => num.length === 10 || num.length === 11)
                            .map(num => num.length === 11 ? num.slice(1) : num);
                        contacts.push(...landlineNums);
                    }
                    
                    // Remove duplicates
                    contacts = [...new Set(contacts)];
                    
                    // Convert Yes/No to boolean
                    const boarding = isBoarding && isBoarding.toString().toLowerCase() === 'yes';
                    const drop = isDrop && isDrop.toString().toLowerCase() === 'yes';
                    
                    // Parse day (should be a number)
                    const dayNum = typeof day === 'number' ? day : parseInt(day) || 0;
                    
                    // Format timing
                    let time = '';
                    if (timing && timing.trim() !== '') {
                        time = timing.toString().trim();
                        // Ensure HH:MM:SS format
                        if (time.split(':').length === 2) {
                            time = time + ':00';
                        }
                    }
                    
                    // Use the tracked current city name
                    const cityName = currentCity || '';
                    
                    // Create the entry
                    const entry = {
                        locationName: stopName.trim(),
                        landmark: '', // Not available in schedule export
                        contact: contacts,
                        city: cityName,
                        state: '', // Not available in schedule export
                        boarding: boarding,
                        drop: drop,
                        day: dayNum,
                        time: time,
                        address: '' // Not available in schedule export
                    };
                    
                    result.push(entry);
                }
                
                i++;
            }
            
            // Sort the results by day first, then by time
            result.sort((a, b) => {
                // First sort by day
                if (a.day !== b.day) {
                    return a.day - b.day;
                }
                
                // If days are equal, sort by time
                if (a.time && b.time) {
                    return a.time.localeCompare(b.time);
                }
                
                // If one has time and other doesn't, put the one with time first
                if (a.time && !b.time) return -1;
                if (!a.time && b.time) return 1;
                
                return 0;
            });
            
            if (result.length > 0) {
                message.success(`Successfully extracted ${result.length} stops from schedule export!`);
            } else {
                message.warning('No valid stops found in the Excel file');
            }
            
            return result;
            
        } catch (error) {
            console.error('Error extracting schedule export data:', error);
            message.error('Failed to extract data from schedule export');
            return [];
        }
    };

    // Handle file upload for QwikBus Schedule Export
    const handleQwikBusFileUpload = (event) => {
        const file = event.target.files[0];
        
        if (!file) {
            return;
        }

        // Check if file is Excel format
        const fileExtension = file.name.split('.').pop().toLowerCase();
        if (!['xlsx', 'xls'].includes(fileExtension)) {
            message.error('Please select a valid Excel file (.xlsx or .xls)');
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                
                // Get the first sheet
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                
                // Convert sheet to JSON
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                
                // Remove completely empty rows
                const filteredData = jsonData.filter(row => 
                    row && row.length > 0 && row.some(cell => cell !== null && cell !== '')
                );
                
                if (filteredData.length === 0) {
                    message.error('Excel file is empty');
                    return;
                }
                
                // Call extractRecordsFromScheduleExport with the processed data
                const extractedData = extractRecordsFromScheduleExport(filteredData);
                
                if (extractedData.length === 0) {
                    return;
                }
                
                // Check for city matches
                const matches = checkCityMatches(extractedData);
                
                if (matches.length > 0) {
                    // Show city confirmation modal
                    setCityMatches(matches);
                    setPendingRouteData(extractedData);
                    setIsCityConfirmationVisible(true);
                } else {
                    // No matches found, proceed directly
                    setRouteData(extractedData);
                    setIsModalVisible(true);
                }
                
            } catch (error) {
                console.error('Error reading Excel file:', error);
                message.error('Failed to read Excel file');
            }
        };
        
        reader.readAsArrayBuffer(file);
        
        // Reset the file input
        event.target.value = '';
    };

    // Handler for Import From QwikBus button click
    const handleImportFromQwikBusClick = () => {
        qwikbusFileInputRef.current.click();
    };

    const isEditing = (record) => record.key === editingKey;

    const edit = (record) => {
        setEditingKey(record.key);
        // Set form values with existing data
        form.setFieldsValue({
            locationName: record.locationName,
            landmark: record.landmark,
            contact: record.contact.join(', '),
            city: record.city, // This will be the city_name from masterCities
            boarding: Boolean(record.boarding),
            drop: Boolean(record.drop),
            day: record.day,
            time: record.time,
            address: record.address
        });
    };

    const cancel = () => {
        setEditingKey('');
        form.resetFields();
    };

    const save = async (key) => {
        try {
            const row = await form.validateFields();
            const newData = [...routeData];
            const index = parseInt(key);
            if (index > -1 && index < newData.length) {
                const item = newData[index];
                
                // Find the selected city object from masterCities
                let selectedCity = null;
                if (row.city && masterCities) {
                    selectedCity = masterCities.find(city => city.city_name === row.city);
                }
                
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                    contact: row.contact.split(',').map(c => c.trim()).filter(c => c),
                    boarding: Boolean(row.boarding),
                    drop: Boolean(row.drop),
                    cityId: selectedCity ? selectedCity.id : item.cityId
                });
                setRouteData(newData);
                setEditingKey('');
                form.resetFields();
                message.success('Record updated successfully!');
            }
        } catch (errInfo) {
            // Validation failed
        }
    };

    const handleDelete = (key) => {
        // Convert key to index since key is the index in our case
        const index = parseInt(key);
        const newData = routeData.filter((_, i) => i !== index);
        setRouteData(newData);
        message.success('Record deleted successfully!');
    };

    // Generate time options for dropdown (24-hour format)
    const generateTimeOptions = () => {
        const options = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 15) { // 15-minute intervals
                const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:00`;
                options.push({
                    value: timeString,
                    label: timeString
                });
            }
        }
        return options;
    };

    const timeOptions = generateTimeOptions();

    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = inputType === 'number' ? (
            <Input type="number" min={1} max={4} />
        ) : inputType === 'checkbox' ? (
            <Checkbox defaultChecked={record[dataIndex]} />
        ) : inputType === 'time' ? (
            <Select
                showSearch
                placeholder="Select time"
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                {timeOptions.map(option => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </Select>
        ) : inputType === 'city' ? (
            <Select
                showSearch
                placeholder="Search and select city"
                optionFilterProp="children"
                filterOption={(input, option) => {
                    const searchText = input.toLowerCase();
                    const optionText = option.children?.toString() || '';
                    return optionText.toLowerCase().includes(searchText);
                }}
            >
                {cityOptions.map(option => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </Select>
        ) : (
            <Input />
        );
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                        rules={[
                            {
                                required: true,
                                message: `Please Input ${title}!`,
                            },
                        ]}
                        valuePropName={inputType === 'checkbox' ? 'checked' : 'value'}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    const columns = [
        {
            title: 'Location Name',
            dataIndex: 'locationName',
            key: 'locationName',
            width: 120,
            editable: true,
            filterable: true,
            onFilter: (value, record) => record.locationName.toLowerCase().includes(value.toLowerCase()),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder="Search Location Name"
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <span style={{ color: filtered ? '#1890ff' : undefined }}>
                    🔍
                </span>
            ),
            render: (text) => (
                <div style={{ 
                    wordWrap: 'break-word', 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                    lineHeight: '1.4'
                }}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Landmark',
            dataIndex: 'landmark',
            key: 'landmark',
            width: 120,
            editable: true,
            filterable: true,
            onFilter: (value, record) => record.landmark.toLowerCase().includes(value.toLowerCase()),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder="Search Landmark"
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <span style={{ color: filtered ? '#1890ff' : undefined }}>
                    🔍
                </span>
            ),
            render: (text) => (
                <div style={{ 
                    wordWrap: 'break-word', 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                    lineHeight: '1.4'
                }}>
                    {text}
                </div>
            ),
        },
        {
            title: 'City',
            dataIndex: 'city',
            key: 'city',
            width: 80,
            editable: true,
            inputType: 'city',
            filters: [...new Set(routeData.map(item => item.city))].map(city => ({
                text: city,
                value: city,
            })),
            onFilter: (value, record) => record.city === value,
            filterIcon: filtered => (
                <span style={{ color: filtered ? '#1890ff' : undefined }}>
                    🔽
                </span>
            ),
            render: (text) => (
                <div style={{ 
                    wordWrap: 'break-word', 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                    lineHeight: '1.4'
                }}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            width: 150,
            editable: true,
            filterable: true,
            onFilter: (value, record) => record.address.toLowerCase().includes(value.toLowerCase()),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder="Search Address"
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <span style={{ color: filtered ? '#1890ff' : undefined }}>
                    🔍
                </span>
            ),
            render: (text) => (
                <div style={{ 
                    wordWrap: 'break-word', 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                    lineHeight: '1.4'
                }}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Contact',
            dataIndex: 'contact',
            key: 'contact',
            width: 60,
            editable: true,
            render: (contacts) => (
                <div style={{ 
                    wordWrap: 'break-word', 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                    lineHeight: '1.4'
                }}>
                    {contacts.join(', ')}
                </div>
            ),
            filterable: true,
            onFilter: (value, record) => record.contact.some(contact => contact.toLowerCase().includes(value.toLowerCase())),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder="Search Contact"
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <span style={{ color: filtered ? '#1890ff' : undefined }}>
                    🔍
                </span>
            ),
        },
        {
            title: 'Boarding',
            dataIndex: 'boarding',
            key: 'boarding',
            width: 30,
            editable: true,
            inputType: 'checkbox',
            render: (boarding) => (
                <div style={{ 
                    wordWrap: 'break-word', 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                    lineHeight: '1.4'
                }}>
                    {boarding ? 'Yes' : 'No'}
                </div>
            ),
        },
        {
            title: 'Drop',
            dataIndex: 'drop',
            key: 'drop',
            width: 30,
            editable: true,
            inputType: 'checkbox',
            render: (drop) => (
                <div style={{ 
                    wordWrap: 'break-word', 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                    lineHeight: '1.4'
                }}>
                    {drop ? 'Yes' : 'No'}
                </div>
            ),
        },
        {
            title: 'Day',
            dataIndex: 'day',
            key: 'day',
            width: 30,
            editable: true,
            inputType: 'number',
            render: (text) => (
                <div style={{ 
                    wordWrap: 'break-word', 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                    lineHeight: '1.4'
                }}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Time',
            dataIndex: 'time',
            key: 'time',
            width: 50,
            editable: true,
            inputType: 'time',
            render: (text) => (
                <div style={{ 
                    wordWrap: 'break-word', 
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                    lineHeight: '1.4'
                }}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Actions',
            dataIndex: 'operation',
            width: 120,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Button
                            type="link"
                            onClick={() => save(record.key)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            Save
                        </Button>
                        <Button type="link" onClick={cancel}>
                            Cancel
                        </Button>
                    </span>
                ) : (
                    <span>
                        <Button
                            type="link"
                            disabled={editingKey !== ''}
                            onClick={() => edit(record)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            Edit
                        </Button>
                        <Popconfirm
                            title={`Are you sure you want to delete "${record.locationName}"?`}
                            description={`This will permanently remove the record for location: ${record.locationName}`}
                            onConfirm={() => handleDelete(record.key)}
                            onCancel={() => {}}
                            okText="Yes, Delete"
                            cancelText="Cancel"
                            okType="danger"
                        >
                            <Button type="link" danger>
                                Delete
                            </Button>
                        </Popconfirm>
                    </span>
                );
            },
        },
    ];

    // Handle city selection in confirmation modal
    const handleCitySelection = (excelCity, selectedCity) => {
        setSelectedCityMappings(prev => ({
            ...prev,
            [excelCity]: selectedCity
        }));
    };

    // Initialize auto-selected cities when modal opens
    React.useEffect(() => {
        if (isCityConfirmationVisible && cityMatches.length > 0) {
            const autoSelections = {};
            cityMatches.forEach(item => {
                if (item.type === 'auto_select' && item.autoSelectedCity) {
                    autoSelections[item.excelCity] = item.autoSelectedCity;
                }
            });
            setSelectedCityMappings(autoSelections);
        }
    }, [isCityConfirmationVisible, cityMatches]);

    // Memoize master cities for better performance
    const memoizedMasterCities = React.useMemo(() => {
        return masterCities || [];
    }, [masterCities]);

    // Create a map for faster city lookup
    const cityMap = React.useMemo(() => {
        const map = new Map();
        memoizedMasterCities.forEach(city => {
            map.set(city.id, city);
        });
        return map;
    }, [memoizedMasterCities]);

    // Memoize city options for table dropdown
    const cityOptions = React.useMemo(() => {
        return memoizedMasterCities.map(city => ({
            value: city.city_name,
            label: `${city.city_name}${city.alias_city_name ? ` / ${city.alias_city_name}` : ''}`
        }));
    }, [memoizedMasterCities]);

    // Handle continue button click in city confirmation modal
    // NOTE: This function does NOT call updateSelectedCity - only stores data for later use
    const handleContinueWithCityMappings = () => {
        setLoading(true);
        
        try {
            // Update route data with selected city mappings
            // Replace city field with user-selected city name
            const updatedRouteData = pendingRouteData.map(record => {
                const selectedCity = selectedCityMappings[record.city];
                if (selectedCity) {
                    return {
                        ...record,
                        city: selectedCity.city_name, // <-- use user-selected city name
                        cityId: selectedCity.id,
                        masterCity: selectedCity // keep reference for later
                    };
                }
                return record;
            });

            // We'll add all cities in the correct order
            const allCities = [];

            // Use updatedRouteData to preserve the original order from Excel, but with user-selected city names
            const routeCityOrder = [];
            updatedRouteData.forEach(record => {
                if (!routeCityOrder.includes(record.city)) {
                    routeCityOrder.push(record.city);
                }
            });
            
            // Map route cities to their selected city objects
            routeCityOrder.forEach((cityName, index) => {
                // Find the selected city mapping for this city name
                // Now cityName is the user-selected city name
                const selectedCity = updatedRouteData.find(r => r.city === cityName)?.masterCity;
                if (selectedCity) {
                    allCities.push(selectedCity);
                }
            });

            // Add cityOrder to each record for later sorting
            const routeDataWithOrder = updatedRouteData.map((record, index) => ({
                ...record,
                cityOrder: routeCityOrder.indexOf(record.city)
            }));
            
            setRouteData(routeDataWithOrder);
            
            // Also call setCitiesChanged if available to notify parent component
            if (props.setCitiesChanged) {
                props.setCitiesChanged(true);
            }
            setIsCityConfirmationVisible(false);
            setIsModalVisible(true);
            
            // Reset state
            setCityMatches([]);
            setPendingRouteData([]);
            setSelectedCityMappings({});
            
            const noMatchCount = cityMatches.filter(item => item.type === 'no_match').length;
            const multipleMatchCount = cityMatches.filter(item => item.type === 'multiple').length;
            const autoSelectCount = cityMatches.filter(item => item.type === 'auto_select').length;
            
            let messageText = 'City mappings stored successfully! Click "Create Route & Update Cities" to add them to your trip.';
            if (autoSelectCount > 0 && noMatchCount > 0 && multipleMatchCount > 0) {
                messageText = `City mappings stored successfully! ${autoSelectCount} cities auto-selected, ${noMatchCount} cities were not found, and ${multipleMatchCount} had multiple matches. Click "Create Route & Update Cities" to add them to your trip.`;
            } else if (autoSelectCount > 0 && noMatchCount > 0) {
                messageText = `City mappings stored successfully! ${autoSelectCount} cities auto-selected and ${noMatchCount} cities were not found in master database. Click "Create Route & Update Cities" to add them to your trip.`;
            } else if (autoSelectCount > 0 && multipleMatchCount > 0) {
                messageText = `City mappings stored successfully! ${autoSelectCount} cities auto-selected and ${multipleMatchCount} had multiple matches. Click "Create Route & Update Cities" to add them to your trip.`;
            } else if (noMatchCount > 0 && multipleMatchCount > 0) {
                messageText = `City mappings stored successfully! ${noMatchCount} cities were not found and ${multipleMatchCount} had multiple matches. Click "Create Route & Update Cities" to add them to your trip.`;
            } else if (autoSelectCount > 0) {
                messageText = `City mappings stored successfully! ${autoSelectCount} cities were auto-selected based on exact matches and state information. Click "Create Route & Update Cities" to add them to your trip.`;
            } else if (noMatchCount > 0) {
                messageText = `City mappings stored successfully! ${noMatchCount} cities were not found in master database. Click "Create Route & Update Cities" to add them to your trip.`;
            } else if (multipleMatchCount > 0) {
                messageText = `City mappings stored successfully! ${multipleMatchCount} cities had multiple matches. Click "Create Route & Update Cities" to add them to your trip.`;
            }
            message.success(messageText);
        } catch (error) {
            message.error('Failed to process city mappings. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    // This is the ONLY function that calls updateSelectedCity
    // All city updates happen here when the Create Route button is clicked
    const createRouteFromExcel = async () => {
        // Get the current table data (including any edited values)
        const currentData = routeData.map((item, index) => ({
            ...item,
            key: index
        }));
        
        // Extract unique cities in the order they appear in the route
        const uniqueCities = [];
        const seenCities = new Set();
        
        // Sort records by cityOrder to preserve the original Excel order
        const sortedData = [...currentData].sort((a, b) => {
            const orderA = a.cityOrder !== undefined ? a.cityOrder : 999;
            const orderB = b.cityOrder !== undefined ? b.cityOrder : 999;
            return orderA - orderB;
        });
        
        // Process records in the sorted order
        sortedData.forEach(record => {
            if (!seenCities.has(record.city)) {
                seenCities.add(record.city);
                uniqueCities.push(record.city);
            }
        });
        
        // Find the corresponding master city objects and set origin/destination flags
        const citiesToAdd = [];
        
        uniqueCities.forEach((cityName, index) => {
            // Find the master city object from stored data
            const cityRecord = currentData.find(record => record.city === cityName);
            const masterCity = cityRecord?.masterCity;
            
            if (masterCity) {
                // Find all records for this city to determine boarding/drop status
                const cityRecords = currentData.filter(record => record.city === cityName);
                const hasBoarding = cityRecords.some(record => record.boarding);
                const hasDrop = cityRecords.some(record => record.drop);
                
                const cityObject = {
                    ...masterCity,
                    isOrigin: hasBoarding,
                    isDestination: hasDrop
                };
                
                citiesToAdd.push(cityObject);
            }
        });
        
        // Use bulk update approach - replace entire cities array at once
        updateSelectedCity(0, citiesToAdd, true); // isBulkUpdate = true
        
        // Notify parent component that cities have changed
        if (props.setCitiesChanged) {
            props.setCitiesChanged(true);
        }
        
        // Create addresses for each route record
        let addressCreationPromises = [];
        let createdAddresses = 0;
        let failedAddresses = 0;
        let skippedAddresses = 0;
        let skippedStopsDueToMissingId = 0; // Counter for stops skipped due to missing IDs
        let addressResults = []; // Store all address creation results

        
        currentData.forEach((record, index) => {
            
            // Check if address already exists by comparing name and city (only if addresses are loaded)
            let existingAddress = null;
            
            if (addressesLoaded && existingAddresses.length > 0) {
                // Check for exact match (both name and city)
                existingAddress = existingAddresses.find(existing => {
                    const nameMatches = existing.name && record.locationName && 
                        existing.name.toLowerCase().trim() === record.locationName.toLowerCase().trim();
                    const cityMatches = existing.city && record.city && 
                        existing.city.toLowerCase().trim() === record.city.toLowerCase().trim();
                    
                    // Only match if both name and city match
                    return nameMatches && cityMatches;
                });
            }
            
            // If we found an existing address with exact name and city match, skip creation
            if (existingAddress) {
                skippedAddresses++;
                
                // Resolve immediately for existing addresses
                const skipPromise = Promise.resolve({ 
                    success: true, 
                    record: existingAddress.name, 
                    data: existingAddress,
                    skipped: true 
                });
                addressCreationPromises.push(skipPromise);
                return;
            }
            
            // Extract first 3 phone numbers from contact array
            const phoneNumbers = record.contact || [];
            const phone_number = phoneNumbers.length > 0 ? phoneNumbers[0] : null;
            const landline_number = phoneNumbers.length > 1 ? phoneNumbers[1] : null;
            const phone_number3 = phoneNumbers.length > 2 ? phoneNumbers[2] : null;
            
            // Prepare address data similar to create-standard-stop page
            const addressData = {
                name: record.locationName,
                latitude: null,
                longitude: null,
                landmark: record.landmark || '',
                address: record.address || '',
                phone_number: phone_number,
                landline_number: landline_number,
                phone_number3: phone_number3,
                city: record.city, // Use city name as shown in table
                is_office: 0,
                agent_user_name: null,
                precedence_number: null,
                is_active: 1,
                operator_code: global.operatorCode // Use global operator code
            };
            
            // Create address using createAddressLocation
            const addressPromise = new Promise((resolve, reject) => {
                createAddressLocation(addressData, 
                    (responseAddressId) => {
                        createdAddresses++;
                        addressData.id = responseAddressId;
                        resolve({ success: true, record: record.locationName, data: addressData, skipped: false });
                    },
                    (errorMsg) => {
                        failedAddresses++;
                        resolve({ success: false, record: record.locationName, error: errorMsg, skipped: false });
                    }
                );
            });
            
            addressCreationPromises.push(addressPromise);
        });
        
        // Wait for all address creation to complete
        try {
            addressResults = await Promise.all(addressCreationPromises);
        } catch (error) {
            failedAddresses = currentData.length;
            message.error('Some addresses failed to create. Please check the results.');
        }


        
        // Transform route data to match TimeMethodStops expected format
        // Group stops by city and create the proper structure
        const cityGroups = {};
        
        currentData.forEach(record => {
            if (!cityGroups[record.city]) {
                cityGroups[record.city] = {
                    city: record.city,
                    displayName: record.city,
                    isActive: true,
                    isBoarding: record.boarding,
                    isDrop: record.drop,
                    stops: []
                };
            }
            
            // Find the corresponding address result for this record
            let addressResult = null;
            let addressData = null;
            
            // Find exact match with record.locationName and city
            addressResult = addressResults.find(result => result.success && result.data && result.record === record.locationName && result.data.city === record.city);
            addressData = addressResult?.data || null;
            
            // Calculate day value: subtract 1 from the original day value
            const calculatedDay = Math.max(0, (record.day || 0) - 1);
            
            // Extract name from address data or use original location name
            const stopName = addressData?.name || addressData?.location_name || record.locationName;
            

            
            // Check if this is the first stop for this city
            const isFirstStopForCity = cityGroups[record.city].stops.length === 0;


            
            // Only add stop if it has a valid ID (addressData exists and has an id)
            if (addressData && addressData.id) {
                cityGroups[record.city].stops.push({
                    displayName: stopName,
                    city: record.city,
                    isActive: 1,
                    isStop: true,
                    timing: record.time || null,
                    day: calculatedDay, // Use calculated day value
                    tripClosePoint: 0, // Will be set by user in TimeMethodStops
                    isBoarding: record.boarding,
                    isDrop: record.drop,
                    phoneNumber: record.contact && record.contact.length > 0 ? record.contact[0] : null,
                    landlineNumber: record.contact && record.contact.length > 1 ? record.contact[1] : null,
                    phoneNumber3: record.contact && record.contact.length > 2 ? record.contact[2] : null,
                    landmark: record.landmark,
                    address: record.address,
                    isMainStop: isFirstStopForCity, // Only first stop for each city will be main stop
                    isNewStop: false, // These are existing stops from Excel
                    // Add address data if available
                    selectedStopId: addressData.id,
                    addressData: addressData,
                    // Add the address name for proper display
                    name: stopName,
                    // Add address ID with correct JSON key for time-method-stops
                    id: addressData.id
                });
            } else {
                // Log warning for stops without valid IDs
                console.warn(`Skipping stop "${record.locationName}" in city "${record.city}" - no valid address ID found`);
                skippedStopsDueToMissingId++;
            }
            
        });
        
        // Convert to array and sort by city order
        const formattedRouteData = Object.values(cityGroups).sort((a, b) => {
            const orderA = uniqueCities.indexOf(a.city);
            const orderB = uniqueCities.indexOf(b.city);
            return orderA - orderB;
        });
        

        
        // Notify parent component with route data
        if (onRouteCreated) {
            onRouteCreated({
                routeData: formattedRouteData,
                cities: citiesToAdd,
                createdAddresses,
                skippedAddresses,
                failedAddresses,
                addressResults: addressResults,
                skippedStopsDueToMissingId: skippedStopsDueToMissingId
            });
        }
        
        // Close the modal
        setIsModalVisible(false);

        // Show success message with address creation results
        let successMessage = `Route created successfully! ${citiesToAdd.length} cities added with proper boarding/drop configuration.`;
        if (createdAddresses > 0) {
            successMessage += ` ${createdAddresses} addresses created successfully.`;
        }
        if (skippedAddresses > 0) {
            successMessage += ` ${skippedAddresses} addresses skipped (already existed in database).`;
        }
        if (failedAddresses > 0) {
            successMessage += ` ${failedAddresses} addresses failed to create.`;
        }
        if (skippedStopsDueToMissingId > 0) {
            successMessage += ` ${skippedStopsDueToMissingId} stops skipped (no valid address ID found).`;
        }
        if (!addressesLoaded) {
            successMessage += ` (Addresses created without duplicate checking - existing addresses were not loaded yet).`;
        }
        
        message.success(successMessage);
    }

    // Owns the loader lifecycle so any failure inside createRouteFromExcel
    // surfaces as an error instead of leaving the spinner running forever
    const handleCreateRoute = async () => {
        setLoading(true);
        setIsCreatingRoute(true);
        try {
            await createRouteFromExcel();
        } catch (error) {
            console.error('Failed to create route from Excel:', error);
            message.error(`Failed to create route: ${error?.message || 'Unexpected error'}. Please try again.`);
        } finally {
            setIsCreatingRoute(false);
            setLoading(false);
        }
    };

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.inputType,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    return (
        <div >
            <Row justify="space-between" style={{ marginBottom: '20px' }}>
                <Col>
                    <Button 
                        type="primary" 
                        onClick={handleImportClick}
                        style={{ marginRight: '10px' }}
                    >
                        Import Excel
                    </Button>
                    <Button 
                        type="default" 
                        onClick={handleImportFromQwikBusClick}
                        style={{ 
                            backgroundColor: '#52c41a',
                            borderColor: '#52c41a',
                            color: 'white'
                        }}
                    >
                        Import From QwikBus Excel
                    </Button>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleFileUpload}
                        style={{ display: 'none' }}
                    />
                    <input
                        ref={qwikbusFileInputRef}
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleQwikBusFileUpload}
                        style={{ display: 'none' }}
                    />
                </Col>
            </Row>

            <Modal
                title="Route Data"
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                width={1400}
                footer={[
                    <Button key="cancel" onClick={() => setIsModalVisible(false)}>
                        Close
                    </Button>,
                    <Button 
                        key="create" 
                        type="primary" 
                        onClick={handleCreateRoute}
                        loading={isCreatingRoute}
                        disabled={!isValidArray(routeData) || routeData.length === 0 || isCreatingRoute}
                    >
                        {isCreatingRoute ? 'Creating Route...' : 'Create Route & Update Cities'}
                    </Button>
                ]}
            >
                {isValidArray(routeData) && routeData.length > 0 && (
                    <Form form={form} component={false}>
                        <Table
                            components={{
                                body: {
                                    cell: EditableCell,
                                },
                            }}
                            bordered
                            dataSource={routeData.map((item, index) => ({ ...item, key: index }))}
                            columns={mergedColumns}
                            rowClassName="editable-row"
                            scroll={{ x: 1500 }}
                            size="middle"
                        />
                    </Form>
                )}
            </Modal>

            {/* City Confirmation Modal */}
            <Modal
                title="City Confirmation Required"
                visible={isCityConfirmationVisible}
                onCancel={() => {
                    setIsCityConfirmationVisible(false);
                    setCityMatches([]);
                    setPendingRouteData([]);
                    setSelectedCityMappings({});
                }}
                width={800}
                footer={[
                    <Button 
                        key="cancel" 
                        onClick={() => {
                            setIsCityConfirmationVisible(false);
                            setCityMatches([]);
                            setPendingRouteData([]);
                            setSelectedCityMappings({});
                        }}
                    >
                        Cancel
                    </Button>,
                    <Button 
                        key="continue" 
                        type="primary" 
                        onClick={handleContinueWithCityMappings}
                        loading={loadingActionRunning}
                        disabled={Object.keys(selectedCityMappings).length !== cityMatches.length || loadingActionRunning}
                    >
                        {loadingActionRunning ? 'Processing...' : 'Continue'}
                    </Button>
                ]}
            >
                <div>
                    <p style={{ marginBottom: '20px', color: '#666' }}>
                        {cityMatches.some(item => item.type === 'auto_select') && 
                         'Some cities have been auto-selected based on exact matches and state information. Please review and confirm:'}
                        {cityMatches.every(item => item.type === 'multiple') && 
                         'Multiple cities found in the master database for the following cities in your Excel file. Please select the correct city for each match:'}
                        {cityMatches.every(item => item.type === 'no_match') && 
                         'The following cities from your Excel file were not found in the master database. Please select the correct city from the master list:'}
                        {cityMatches.some(item => item.type === 'multiple') && cityMatches.some(item => item.type === 'no_match') && 
                         'Multiple cities found and some cities not found in the master database. Please select the correct city for each match:'}
                    </p>
                    
                    <List
                        dataSource={cityMatches}
                        renderItem={(item, index) => {
                            return (
                                <List.Item key={index}>
                                    <Card 
                                        title={`Excel City: "${item.excelCity}"`} 
                                        style={{ width: '100%', marginBottom: '10px' }}
                                        extra={
                                            item.type === 'no_match' ? (
                                                <span style={{ 
                                                    color: '#ff4d4f', 
                                                    fontSize: '12px',
                                                    backgroundColor: '#fff2f0',
                                                    padding: '2px 6px',
                                                    borderRadius: '3px'
                                                }}>
                                                    No Match Found
                                                </span>
                                            ) : item.type === 'auto_select' ? (
                                                <span style={{ 
                                                    color: '#52c41a', 
                                                    fontSize: '12px',
                                                    backgroundColor: '#f6ffed',
                                                    padding: '2px 6px',
                                                    borderRadius: '3px'
                                                }}>
                                                    Auto-Selected
                                                </span>
                                            ) : (
                                                <span style={{ 
                                                    color: '#1890ff', 
                                                    fontSize: '12px',
                                                    backgroundColor: '#f0f8ff',
                                                    padding: '2px 6px',
                                                    borderRadius: '3px'
                                                }}>
                                                    Multiple Matches
                                                </span>
                                            )
                                        }
                                    >
                                        <div style={{ marginBottom: '10px' }}>
                                            <strong>Select the correct city:</strong>
                                            {item.type === 'auto_select' && (
                                                <span style={{ 
                                                    color: '#52c41a', 
                                                    marginLeft: '10px',
                                                    fontSize: '12px'
                                                }}>
                                                    (Auto-selected based on exact match and state)
                                                </span>
                                            )}
                                        </div>
                                        <Select
                                            style={{ width: '100%' }}
                                            showSearch
                                            placeholder="Search and select city"
                                            onChange={(value) => {
                                                const selectedCity = item.matches.find(city => city.id === value);
                                                handleCitySelection(item.excelCity, selectedCity);
                                            }}
                                            value={selectedCityMappings[item.excelCity]?.id}
                                            optionFilterProp="children"
                                            filterOption={(input, option) => {
                                                const searchText = input.toLowerCase();
                                                const optionText = option.children?.toString() || '';
                                                return optionText.toLowerCase().includes(searchText);
                                            }}
                                        >
                                            {item.matches.map((city) => (
                                                <Option key={city.id} value={city.id} data={city}>
                                                    {city.city_name}{city.alias_city_name ? " / " + city.alias_city_name : null}
                                                    {city.state_name && (
                                                        <span style={{ color: '#999', marginLeft: '5px', fontSize: '12px' }}>
                                                            - {city.state_name}
                                                        </span>
                                                    )}
                                                    {city.matchType && (
                                                        <span style={{ 
                                                            color: city.matchType.includes('exact') ? '#52c41a' : '#1890ff', 
                                                            marginLeft: '10px', 
                                                            fontSize: '12px',
                                                            backgroundColor: city.matchType.includes('exact') ? '#f6ffed' : '#f0f8ff',
                                                            padding: '2px 6px',
                                                            borderRadius: '3px'
                                                        }}>
                                                            {city.matchType.replace('_', ' ')}
                                                        </span>
                                                    )}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Card>
                                </List.Item>
                            );
                        }}
                    />
                </div>
            </Modal>
        </div>
    );
};
